import { createRouter, createWebHistory } from "vue-router";
import { AuthService } from "@/revamp/firebase/config";
import { UserUpdate } from "@/components";
import { Dashboard, Locations } from "@/views";
import {
  Return,
  Welcome,
  FourOhFour,
  VerifyEmail,
  CompleteSignup,
  OutletScan,
  updateEmail,
  ResetPassword,
  Borrow,
  CharitySelection,
  DonationConfirmation,
  DonationSuccess,
  BinScan,
  BinScanResult,
} from "@/revamp/views";

const authRoutes = (to, from, next) => {
  let user = AuthService.currentUser;
  if (!user) {
    next({ name: "Welcome" });
  } else {
    next();
  }
};

const noAuth = (to, from, next) => {
  let user = AuthService.currentUser;
  if (user) {
    next({ name: "Dashboard" });
  } else {
    next();
  }
};

const routes = [
  {
    path: "/",
    name: "Welcome",
    component: Welcome,
    beforeEnter: noAuth,
  },
  {
    path: "/return",
    name: "Return",
    component: Return,
  },
  // {
  //   path: "/borrow",
  //   name: "Borrow",
  //   component: Borrow,
  //   beforeEnter: noAuth,
  // },
  {
    path: "/charity-selection",
    name: "CharitySelection",
    component: CharitySelection,
    beforeEnter: noAuth,
  },
  {
    path: "/donation-confirmation",
    name: "DonationConfirmation",
    component: DonationConfirmation,
    beforeEnter: noAuth,
  },
  {
    path: "/donation-success",
    name: "DonationSuccess",
    component: DonationSuccess,
    beforeEnter: noAuth,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: authRoutes,
  },
  {
    path: "/locations",
    name: "Locations",
    component: Locations,
  },
  {
    path: "/verifyEmail",
    name: "VerifyEmail",
    component: VerifyEmail,
  },
  {
    path: "/completeSignup",
    name: "CompleteSignup",
    component: CompleteSignup,
  },
  {
    path: "/change_password",
    name: "ChangePassword",
    component: UserUpdate,
  },
  {
    path: "/change_email_request",
    name: "ChangeEmailRequest",
    component: UserUpdate,
  },
  {
    path: "/updateEmail",
    name: "UpdateEmail",
    component: updateEmail,
  },
  {
    path: "/resetPassword",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/:code([a-zA-Z0-9]{5})",
    redirect: (to) => ({ name: "Return", query: { url: `${window.location.origin}${to.fullPath}` } }),
  },
  {
    path: "/quickscan/:banner([a-zA-Z]+)/:store(R[0-9]{6})",
    name: "Farmboy Quick Scan",
    component: OutletScan,
  },
  {
    path: "/bin/:binId",
    name: "BinScan",
    component: BinScan,
  },
  {
    path: "/bin/:binId/result",
    name: "BinScanResult",
    component: BinScanResult,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "FourOhFour",
    component: FourOhFour,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
